import { ReactNode } from 'react';
import {
    tradeLinks,
    sellerLinks,
    companyLinks,
    sitemapLinks,
    connectLinks,
    ampConnectLinks,
} from './Footer/links';
import { FormattedMessage } from 'dibs-react-intl';
import { FooterLink, enablerKeys } from './Footer/FooterLinkTypes';
import { Footer_viewer } from './Footer/__generated__/Footer_viewer.graphql';

export type PartialFooterLinkConfig = {
    title: ReactNode;
    items: FooterLink[];
    enablerKey?: enablerKeys;
    disablerKey?: enablerKeys;
};

export type FooterLinkConfig = PartialFooterLinkConfig & {
    additionalLink?: PartialFooterLinkConfig;
    sectionName?: string;
    columnWidth: number;
};

const tradeLinksConfig: PartialFooterLinkConfig = {
    title: <FormattedMessage id="footer.tradeLinks.title" defaultMessage="Trade" />,
    items: tradeLinks,
};

const sellerLinksConfig: PartialFooterLinkConfig = {
    title: <FormattedMessage id="footer.sellerLinks.title" defaultMessage="Sellers" />,
    items: sellerLinks,
};

const companyLinksConfig: PartialFooterLinkConfig = {
    title: <FormattedMessage id="footer.ourCompany.title" defaultMessage="Our Company" />,
    items: companyLinks,
};

const sitemapLinksConfig: PartialFooterLinkConfig = {
    title: <FormattedMessage id="footer.categories.title" defaultMessage="Categories" />,
    items: sitemapLinks,
    enablerKey: 'isSiteMapsEnabled',
};

const connectLinksMessage = (
    <FormattedMessage id="footer.connect.title" defaultMessage="Connect With Us" />
);

const connectLinksConfig: PartialFooterLinkConfig = {
    title: connectLinksMessage,
    items: connectLinks,
};

export const ampConnectLinksConfig: PartialFooterLinkConfig = {
    title: connectLinksMessage,
    items: ampConnectLinks,
};

export const linkColumnConfig: FooterLinkConfig[] = [
    {
        ...tradeLinksConfig,
        additionalLink: sellerLinksConfig,
        columnWidth: 2,
    },
    {
        ...companyLinksConfig,
        columnWidth: 2,
    },
    {
        ...sitemapLinksConfig,
        columnWidth: 3,
    },
    {
        ...connectLinksConfig,
        sectionName: 'connect-with-us',
        columnWidth: 3,
    },
];

export const mobileLinkDrawerConfig = [
    tradeLinksConfig,
    sellerLinksConfig,
    companyLinksConfig,
    sitemapLinksConfig,
    connectLinksConfig,
];

export const filterLinks = (links: FooterLink[], viewer: Footer_viewer): FooterLink[] => {
    return links.filter(link => {
        if (
            (link.enablerKey && viewer[link.enablerKey] === false) ||
            (link.disablerKey && viewer[link.disablerKey] === true)
        ) {
            return null;
        }
        return link;
    });
};
